<template>
 <div style=" padding:20px;margin-top:10px;background: #fff;  " >
 <el-table v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
    height="600">
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==0" 
      width="5%">
    </el-table-column>
    <el-table-column
      fixed
      prop="create_time"
      label="日期"
      min-width="20%">
    </el-table-column>
    <el-table-column
      prop="nation"
      label="区域"
      min-width="30%">
    </el-table-column>
    <el-table-column
      prop="keywords"
      label="关键词"
      min-width="30%">
    </el-table-column>
    <el-table-column
      prop="tableCName"
      label="类别"
      min-width="10%">
    </el-table-column>	
 
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
  <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination> </div>
  </div>
</template>
 
<script>
export default {
    data() {
      return {
	  	page: 1,
		id: 1,
		total: 0,
		size:10,
	    is_loading: false,
		loading: true,
        tableData: [],
      }
    },
    props: {
        titleSync: String,
      },
	  
    methods: {
		handlePageChange(val) {
			this.page = val;
			//保存到localStorage
			localStorage.setItem('adPage', this.page)
			localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
			this.getInfo()
		},
 		
	  getInfo(){
 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		let curPage = that.page;
        console.log( userInfo);  
		  $.ajax({
              type: "POST",
			  data:  {user_id: info.id, page: curPage, size: 10},
              url: "https://www.myferp.com/admin/user/queryLog",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.loading = false;
			      Vue.prototype.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        
				console.log(JSON.stringify(data));
				that.tableData = data.data.data ; 
				that.page = data.data.currentPage;
                that.total = data.data.count;
                that.loading = false;				
                }
              });	
	  },
 
      onSubmit() { 
			 
			     
      }
    },
    mounted() {
	  this.getInfo();
	},
    computed: {
 
      },	
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/queryLog.vue